import {useCallback, useState} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';

import {getSearchParam, isFunction, setSearchParams} from '~ui/utils';

import {useLatest} from './use-latest';

export function useSearchParamsState<T>(name: string, deserialize: (value: string | null) => T) {
    const navigate = useNavigate();
    const location = useLocation();

    const [value, setValue] = useState(() => deserialize(getSearchParam(location.search, name)));
    const latestValue = useLatest(value);

    const updateValue = useCallback(
        (newValue: React.SetStateAction<T>) => {
            const actualNewValue = isFunction(newValue) ? newValue(latestValue.current) : newValue;

            setValue(actualNewValue);

            const newSearch =
                actualNewValue === null
                    ? ''
                    : setSearchParams({[name]: String(actualNewValue)}, location.search);

            navigate(
                {
                    search: newSearch,
                },
                {replace: true},
            );
        },
        [navigate, location, latestValue, name],
    );

    return [value, updateValue] as const;
}
